export const formatDateTime = (dateString: String) => {
  return dateString.replace("T", ", ").replace(".000Z", "");
};

export const getDayName = (isoString: string) => {
  const today = new Date();
  const date = new Date(isoString);

  const isToday =
    date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() === today.getDate();

  if (isToday) {
    return "Today";
  }

  if (date.getFullYear() === today.getFullYear()) {
    return date.toLocaleString("en-US", {
      weekday: "long",
      day: "numeric",
      month: "long",
    });
  } else {
    return date.toLocaleString("en-US", {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  }
};
export const convertToLocalDateTime = (isoString: string) => {
  const date = new Date(isoString);

  return date
    .toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZoneName: "short",
      hour12: true, // Use 24-hour format
    })
    .replace(",", ""); // Remove default comma
};

export const convertToTimeOnly = (isoString: string) => {
  const date = new Date(isoString);

  return date
    .toLocaleString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })
    .replace(",", "");
};

export const convertLocalDateStrToUtc = (
  localDateStr: string,
  endDayTime = false,
): string => {
  // Ensure we get year, month, and day correctly
  const [year, month, day] = localDateStr.split("-").map(Number);

  // Create a UTC date with the correct time
  const utcDate = new Date(
    Date.UTC(
      year,
      month - 1, // JavaScript months are 0-based
      day,
      endDayTime ? 23 : 0, // Hours
      endDayTime ? 59 : 0, // Minutes
      endDayTime ? 59 : 0, // Seconds
    ),
  );

  console.log(`Converted UTC: ${utcDate.toISOString()}`);

  return utcDate.toISOString();
};

export const calculateDaysBetweenDates = (
  firstDate: Date,
  secondDate: Date,
): number => {
  const oneDay = 24 * 60 * 60 * 1000;

  return Math.round(
    Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay),
  );
};

export const areDatesDifferent = (firstDate: string, secondDate: string) => {
  const date1 = new Date(firstDate);
  const date2 = new Date(secondDate);

  return (
    date1.getFullYear() !== date2.getFullYear() ||
    date1.getMonth() !== date2.getMonth() ||
    date1.getDate() !== date2.getDate()
  );
};
